import { FormattedMessage } from "react-intl";

import {
    ATLASSIAN_SUPPORT_CENTER_SUPPORTED_LOCALES,
    DEFAULT_VALUES,
    useLocalizedHref
} from "@/libraries/web-framework";
const AtlassianIntelligence = () => {
    const localizedHref = `https://support.atlassian.com${useLocalizedHref(
        "/organization-administration/docs/get-started-with-atlassian-intelligence/",
        { supportedLocales: ATLASSIAN_SUPPORT_CENTER_SUPPORTED_LOCALES }
    )}`;
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.atlassianIntelligence.content.body"
                    defaultMessage="Communicate efficiently, glean relevant insights, and work on what matters with AI capabilities. These include AI-powered editing experiences, quick summaries of long pages, and more. <a>Learn more.</a>"
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-label-english="learn more"
                                data-track-event="ConfluencePricingPageTeam24.atlassianInteligence.learnMore"
                                data-event-container="ConfluencePriceFinderTeam24"
                                href={localizedHref}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};
export default AtlassianIntelligence;
